import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "nbspIfEmpty",
    standalone: false
})
export class NbspIfEmptyPipe implements PipeTransform {
	transform(value: string, format?: string): any {
		return value ? value : format ? format : "&nbsp";
	}
}
